import { random } from "lodash-es";
import { SiteKey } from "~/shared/types/site";

const logoPaths = {
  harmony: [
    'logo_musicians.webp',
  ],
  edmusic: [
    'violin.webp'
  ],
  freehold: [
    '1.png'
  ],
  admin: [
    'site_cover.png'
  ],
  beatsperminute: [
    'logo_450.webp',
  ],
  harmonyparts: [
    //'png/1.png',  bad ai
    'png/2.png',
  ],
  nickels: [
    'lg/logo_lg.webp',
  ],
  music: [
    'santana.webp',
  ]
} as const;

export const publicStorageUrl = (subpath: string) => (
  `https://r2-common-resources-bucket.beatsperminuteonline.com/${subpath}`
)

// TODO: remove this, and default to some pattern per site
export const mainLogoUrl = publicStorageUrl('harmony/images/logos/logo_musicians_sm.webp');

export const randomLogoUrl = (siteKey: SiteKey) => {
  const paths = logoPaths[siteKey];
  if (!paths) return undefined;
  const randomKey = random(0, logoPaths[siteKey].length - 1);
  return publicStorageUrl(`${siteKey}/images/logos/${paths[randomKey]}`);
}